import React from 'react';

function WindowSmall() {
  return (
    <div className="div-intro-window display-flex-420">
      <div className="div-intro-content-container">
        <p>Greetings,</p>
        <p>my name is</p>
        <p>James Page</p>
        <p>and I'm a</p>
        <h1>Full Stack</h1>
        <h1>Web Developer</h1>
        <p>Building</p>
        <p>friendly responsive and web</p>
        <p>applications</p>
      </div>
    </div>
  );
}

export default WindowSmall;